<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">
          {{ $t('user.table.columns.name') }}
        </th>
        <th scope="col" class="border-0">
          {{ $t('user.table.columns.email') }}
        </th>
        <th scope="col" class="border-0">
          {{ $t('user.table.columns.role') }}
        </th>
        <th scope="col" class="border-0">
          {{ $t('user.table.columns.options') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in users" :key="index">
        <td>{{ row.id }}</td>
        <td class="td-4 link">
          <d-link :to="{ name: 'admin-user-edit', params: { userId: row.id } }">
            {{ row.name }}
          </d-link>
        </td>
        <td class="td-3">{{ row.email }}</td>
        <td class="td-2">
          {{
            row.settings.role.name
              ? row.settings.role.name
              : $t('user.account.roles.administrator')
          }}
        </td>
        <td class="td-2">
          <user-buttons :user="row"></user-buttons>
        </td>
      </tr>
      <tr v-if="users.length === 0">
        <td colspan="7" class="no-content">
          {{ $t('user.table.noContent') }}
        </td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      :title="$t('user.delete.title')"
      :message="$t('user.delete.message')"
    />
  </table>
</template>

<script>
import Events from '_utils/events';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import UserButtons from './UserButtons.vue';
import UserDelete from './UserDelete';
import { _DELETE_USER_ } from './UserModel';

export default {
  name: 'user-table',
  mixins: [UserDelete],
  components: {
    UserButtons,
    ConfirmationModal,
  },
  props: {
    users: {
      type: Array,
    },
  },
  data() {
    return {
      selectUser: null,
    };
  },
  mounted() {
    Events.$on(_DELETE_USER_, user => {
      this.selectUser = user.id;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  a {
    cursor: pointer;
  }
}

.td {
  &-2 {
    min-width: 140px;
  }
  &-3 {
    min-width: 140px;
  }
  &-4 {
    min-width: 200px;
  }
}
</style>
